import React from "react";

const ButtonLoader = () => {
  return (
    <div className="button-loader">
      <div className="spinner"></div> Loading...
    </div>
  );
};

export default ButtonLoader;